import React from 'react';
import './ResetPassword.scss'
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import { PASSWORD_RESET } from '../../api/urls';

const ResetPassword: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = React.useState('');
  const [emailTouched, setEmailTouched] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);
  const [linkSent, setLinkSent] = React.useState(false);

  const isValidEmail = (value: string) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setEmailTouched(true);
    setError(null);

    if (!isValidEmail(email)) {
      setError('Podaj poprawny adres email');
      return;
    }

    setLoading(true);
    try {
      await fetch(PASSWORD_RESET, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      setLinkSent(true);
    } catch (err: any) {
      setError('Wystąpił błąd podczas wysyłania linku resetującego');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className='d-flex justify-content-center pt-5'>
        <img
          alt='mooveno-logo'
          className="logo"
          src={`/login/mooveno-logo-dark.svg`}
          style={{ width: 200, height: 'auto', maxWidth: '90%', cursor: 'pointer' }}
          onClick={() => navigate('/login')}
        />
      </div>
      <div className='card-margins d-flex justify-content-center row'>
        <Card style={{ borderRadius: '14px', maxWidth: 480, width: '100%' }}>
          {!linkSent ? (
            <>
              <div className="d-flex flex-column align-items-center mb-5">
                <h4>Resetowanie hasła</h4>
                <span className='input-email'>Podaj adres email powiązany z Twoim kontem, a prześlemy tam link do zmiany hasła.</span>
              </div>
              <form onSubmit={onSubmit} className='d-flex column gap-3 justify-content-center'>
                <div className='password-input'>
                  <div className='pb-4'>
                    <span className="p-float-label">
                      <InputText
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        onBlur={() => setEmailTouched(true)}
                        className={`w-100${emailTouched && !isValidEmail(email) ? ' p-invalid' : ''}`}
                        autoComplete="email"
                        type="email"
                      />
                      <label htmlFor="email">Adres email</label>
                    </span>
                  </div>
                  <Button
                    className="login-button"
                    type='submit'
                    label={loading ? 'Wysyłanie…' : 'Wyślij link resetujący'}
                    loading={loading}
                    disabled={!email || !isValidEmail(email) || loading}
                  />
                  <div style={{ minHeight: '24px', marginTop: '8px', marginBottom: '0' }}>
                    {(error || (emailTouched && !isValidEmail(email))) && (
                      <div className='text-danger' role='alert'>
                        {error || 'Podaj poprawny adres email'}
                      </div>
                    )}
                  </div>
                </div>
              </form>
              <div className='d-flex justify-content-center text-justify' style={{ fontSize: '14px' }}>
                <span>Link resetujący będzie ważny przez 15 minut<br></br>
                  Nie otrzymałeś emaila? Sprawdź folder spam</span>
              </div>
            </>
          ) : (
            <div className="d-flex flex-column align-items-center pb-2">
              <img
              alt='mooveno-logo'
              className="logo"
              src={`/login/password-reset-mail.svg`}
              style={{ width: 100, height: 'auto', maxWidth: '90%', cursor: 'pointer' }}
              onClick={() => navigate('/')}
              />
              <h2>Link został wysłany!</h2>
              <span className="text-center mb-4" style={{ fontWeight: 400, color: '#4C6483' }}>
                Link do zmiany Twojego hasła został Ci przesłany na adres: {email}
              </span>
              <div className='d-flex justify-content-center text-justify px-5' style={{ fontSize: '14px' }}>
                <p>Link resetujący będzie ważny przez 15 minut<br></br>
                  Nie otrzymałeś emaila? Sprawdź folder spam</p>
              </div>
              <Button
                className="go-back-login-button"
                label={"Powrót do logowania"}
                icon="pi pi-arrow-left"
                iconPos="left"
                onClick={() => navigate('/login/')}
                style={{ borderRadius: '10px' }}
              />
            </div>
          )}
        </Card>
        <p className='d-flex justify-content-center pt-4'>© 2025 Mooveno. Wszystkie prawa zastrzeżone</p>
      </div>
    </>
  );
};

export default ResetPassword;